module.exports = __webpack_public_path__ + "img/map.2b66750b.svg";